var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "ob1-cards",
        {
          staticClass: "bg-white p-1",
          attrs: { "with-composite-link": false },
        },
        [
          _c("div", { staticClass: "d-flex flex-row justify-content-center" }, [
            _c("div", { staticClass: "ob1-skeleton" }, [
              _c("div", {
                staticClass: "ob1-skeleton-white mb-1",
                staticStyle: { width: "100px", height: "30px" },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex flex-row justify-content-center" }, [
            _c("div", { staticClass: "ob1-skeleton" }, [
              _c("div", {
                staticClass: "ob1-skeleton-white mb-1",
                staticStyle: { width: "200px", height: "30px" },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex flex-row justify-content-center" }, [
            _c("div", { staticClass: "ob1-skeleton" }, [
              _c("div", {
                staticClass: "ob1-skeleton-white mb-1",
                staticStyle: { width: "140px", height: "175px" },
              }),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }